<form (submit)="add()"
      action="#">
  <p-autoComplete [placeholder]="'USER.ADD_USER_PLACEHOLDER' | translate"
                  [(ngModel)]="queryText"
                  [ngModelOptions]="{ standalone: true }"
                  [autoHighlight]="true"
                  field="name"
                  [suggestions]="usersFiltered"
                  (completeMethod)="filterUsers($event)">
    <ng-template let-user
                 pTemplate="item">
      <div>{{ user.name }} ({{ user.email }})</div>
    </ng-template>
  </p-autoComplete>

  <button class="pop-button pop-border-left-none"
          type="submit"
          [disabled]="!queryText"
          translate="BUTTON.ADD"></button>
</form>
